import { css } from 'styled-components';
import token from 'styled-token';

/** @class AccordionPanelMixin */
/** @method */
export var AccordionPanelMixin = function AccordionPanelMixin(props) {
  return token({
    backgroundColor: 'AccordionPanel.backgroundColor',
    borderColor: 'AccordionPanel.borderColor',
    borderRadius: 'AccordionPanel.borderRadius',
    borderWidth: 'AccordionPanel.borderWidth',
    margin: 'AccordionPanel.margin',
    padding: 'AccordionPanel.padding'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius,
      borderWidth = _ref.borderWidth,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 0 : _ref$padding;
    return css(["background-color:", ";border-radius:0 0 ", "px ", "px;border-top:", "px solid ", ";padding:", "px;margin:", "px;"], backgroundColor, borderRadius, borderRadius, borderWidth, borderColor, padding, margin);
  })(props);
};